import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";

const createSelectors = parentReducer => {
    return new (class {
        selectBroadcasts = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["NewsBroadcastV2Widget_reducer"];
            return reducer.broadcasts;
        };

        selectProfile = store => {
            const reducer = store["UserProfile_reducer"];
            let userInfo = reducer.user;
            return userInfo;
        };
        getUserProfile = createSelector(
            [this.selectProfile],
            (profiles = false) => {
                if (
                    profiles === false ||
                    typeof profiles === "undefined" ||
                    profiles === null
                ) {
                    return [];
                }
                let name = profiles.profile.first_name + " " + profiles.profile.last_name
                let uid = profiles.profile.uid
                return {
                    name,
                    uid
                };
            }
        );

        selectAllBroadcastList = createSelector(
            [this.selectBroadcasts],
            (broadcast = false) => {
                if(broadcast) {
                    let regBroadcasts = Object.keys(broadcast).map(e => {
                        return broadcast[e];
                    });
                    return _.orderBy(regBroadcasts, "timestamp", ["desc"]);
                    }
                else {
                    return false;
                }
            }
        );

        selectActiveBroadcast = createSelector(
            [this.selectBroadcasts],
            (broadcasts = false) => {
                if (broadcasts) {
                    let times = Object.keys(broadcasts).map(timestamp =>
                        moment(timestamp, "DD-MM-YYYY hh:mm:ss")
                    );
                    let mostRecent = moment.max(times);
                    return broadcasts[mostRecent._i];
                } else {
                    return false;
                }
            }
        );
    })();
};
export default createSelectors;
